'use strict'

var imageLoader = require('../lib/imageLoader.js');

function initCarousel() {
	var images = window.mastheadImages;
	if (!images || (images.length <= 1))
		return

	var mastheadEl = document.getElementsByClassName('masthead')[0];
	var imageFrameEl = mastheadEl.getElementsByClassName('image')[0];

	var currentIndex = 0;
	var carouselTimer = undefined;
	var slides = [imageFrameEl.getElementsByClassName('fluid')[0]];

	activateSlide(currentIndex);
	buildImageLoader(currentIndex + 1);

	function activateSlide(index) {
		if (slides.length > 2) {
			var previousIndex = index === 0 ? images.length - 1 : index - 1;
			slides[previousIndex].classList.remove('active');
		}
		slides[index].classList.add('active');
	}

	function buildImageLoader(index) {
		imageLoader([images[index]]).then(function(response) {
			buildTimeout(response[0]);
		}).catch(function(error) {
			console.error(error);
		});
	}

	function buildTimeout(response) {
		carouselTimer = window.setTimeout(function() {
			if (response) {
				buildImage(response);
			}

			activateSlide(currentIndex);
			currentIndex = currentIndex < images.length - 1 ? currentIndex + 1 : 0;

			if (slides.length < images.length) {
				buildImageLoader(currentIndex + 1);
			} else {
				buildTimeout();
			}
		}, 4000);
	}

	function buildImage(imgSrc) {
		var newSlide = document.createElement('span');

		var gravityClass = imgSrc.match(/gravity=(.*?)\&/)[1];
		newSlide.classList.add(gravityClass);

		newSlide.classList.add('fluid');
		newSlide.style.backgroundImage = 'url(' + imgSrc + ')';
		slides.push(imageFrameEl.insertBefore(newSlide, null));
	}
}

module.exports = {
	init: function() {
		initCarousel();
	}
};